import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Teleport as _Teleport, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-652cd998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-upload-menu",
  ref: "menuRef"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-upload-menu__icon icon icon-tablet" }, null, -1))
const _hoisted_3 = { class: "d-upload-menu__text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-upload-menu__icon icon icon-add-folder" }, null, -1))
const _hoisted_5 = { class: "d-upload-menu__text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-upload-menu__divider" }, null, -1))
const _hoisted_7 = { class: "d-upload-menu__item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-upload-menu__icon icon icon-image" }, null, -1))
const _hoisted_9 = { class: "d-upload-menu__text btn-ico" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "d-upload-menu__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-upload-menu__icon icon icon-image" }, null, -1))
const _hoisted_13 = { class: "d-upload-menu__text btn-ico" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { for: "fileInputTUS" }
const _hoisted_16 = { class: "d-upload-menu__item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-upload-menu__icon icon icon-upload-file" }, null, -1))
const _hoisted_18 = { class: "d-upload-menu__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!

  return (_openBlock(), _createBlock(_Transition, { name: "smooth" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCase && _ctx.addCase(...args))),
          class: "d-upload-menu__item"
        }, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$localize('drive.button.add.case')), 1)
        ]),
        (_ctx.showNewFolder)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addFolder && _ctx.addFolder(...args))),
              class: "d-upload-menu__item"
            }, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$localize('drive.button.add.folder')), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("label", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$localize('drive.button.add.photo')), 1),
            (_openBlock(), _createElementBlock("input", {
              ref: "mediaInputRef",
              key: _ctx.mediaLoadedKey,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadTUS($event))),
              accept: "image/*",
              capture: "environment",
              type: "file",
              multiple: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($event.target.value=''))
            }, null, 544))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("label", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$localize('drive.button.add.video')), 1),
            (_openBlock(), _createElementBlock("input", {
              key: _ctx.mediaLoadedKey,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.uploadTUS($event))),
              accept: "video/*",
              capture: "environment",
              type: "file",
              multiple: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($event.target.value=''))
            }, null, 32))
          ])
        ]),
        _createElementVNode("label", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$localize('drive.button.add.files')), 1)
          ]),
          _createElementVNode("input", {
            id: "fileInputTUS",
            ref: "fileInputTUS",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadTUS($event))),
            style: {"display":"none"},
            type: "file",
            multiple: "",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($event.target.value=''))
          }, null, 544)
        ]),
        (_ctx.isSaving)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 1,
              message: _ctx.loaderText
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_app_take_photo, {
            ref: "appTakePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMultipleUpload,
            onOnRetake: _ctx.handleMediaCancel,
            "z-index": "3500",
            "is-case-cropper": ""
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
        ]))
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}